import { QueryKey } from "@tanstack/react-query";

export const PROJECT_KEYS = {
  PROJECTS: "projects",
  GET_PROJECTS: (params: unknown): QueryKey => [PROJECT_KEYS.PROJECTS, params],
};
